/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SiteAssetMapAssetResponseDto } from './SiteAssetMapAssetResponseDto';
import {
    SiteAssetMapAssetResponseDtoFromJSON,
    SiteAssetMapAssetResponseDtoFromJSONTyped,
    SiteAssetMapAssetResponseDtoToJSON,
    SiteAssetMapAssetResponseDtoToJSONTyped,
} from './SiteAssetMapAssetResponseDto';
import type { SiteLookupResponseDto } from './SiteLookupResponseDto';
import {
    SiteLookupResponseDtoFromJSON,
    SiteLookupResponseDtoFromJSONTyped,
    SiteLookupResponseDtoToJSON,
    SiteLookupResponseDtoToJSONTyped,
} from './SiteLookupResponseDto';

/**
 * 
 * @export
 * @interface GetSiteAssetsMapResponseDto
 */
export interface GetSiteAssetsMapResponseDto {
    /**
     * 
     * @type {SiteLookupResponseDto}
     * @memberof GetSiteAssetsMapResponseDto
     */
    site: SiteLookupResponseDto;
    /**
     * 
     * @type {Array<SiteAssetMapAssetResponseDto>}
     * @memberof GetSiteAssetsMapResponseDto
     */
    assets: Array<SiteAssetMapAssetResponseDto>;
}

/**
 * Check if a given object implements the GetSiteAssetsMapResponseDto interface.
 */
export function instanceOfGetSiteAssetsMapResponseDto(value: object): value is GetSiteAssetsMapResponseDto {
    if (!('site' in value) || value['site'] === undefined) return false;
    if (!('assets' in value) || value['assets'] === undefined) return false;
    return true;
}

export function GetSiteAssetsMapResponseDtoFromJSON(json: any): GetSiteAssetsMapResponseDto {
    return GetSiteAssetsMapResponseDtoFromJSONTyped(json, false);
}

export function GetSiteAssetsMapResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSiteAssetsMapResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'site': SiteLookupResponseDtoFromJSON(json['site']),
        'assets': ((json['assets'] as Array<any>).map(SiteAssetMapAssetResponseDtoFromJSON)),
    };
}

export function GetSiteAssetsMapResponseDtoToJSON(json: any): GetSiteAssetsMapResponseDto {
    return GetSiteAssetsMapResponseDtoToJSONTyped(json, false);
}

export function GetSiteAssetsMapResponseDtoToJSONTyped(value?: GetSiteAssetsMapResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'site': SiteLookupResponseDtoToJSON(value['site']),
        'assets': ((value['assets'] as Array<any>).map(SiteAssetMapAssetResponseDtoToJSON)),
    };
}

